module.exports = __webpack_public_path__ + "static/media/cloud-rain.039f7a92.svg";